import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../providers/CustomDataProvider';
import { listRelayDeposits } from '../../services/relayDepositService';

export class RelayDepositDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'relay') {
      return Promise.reject(new Error('Unsupported getList resource'));
    }

    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};

    try {
      const result = await listRelayDeposits({
        page,
        pageSize: perPage,
        userEvmAddress: filter.userEvmAddress || undefined,
        userSolAddress: filter.userSolAddress || undefined,
        depositAddress: filter.depositAddress || undefined,
      });

      const data = (result.data ?? []).map((row) => ({
        ...row,
        id: row.id,
      }));

      return { data, total: result.total ?? data.length };
    } catch (error) {
      console.error('RelayDepositDataProvider getList error:', error);
      throw error;
    }
  }
}

export const relayDepositDataProvider = new RelayDepositDataProvider();
